import React, {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
} from "react";

interface CompareContextType {
    compareArray: number[];
    toggleCompareArray: (id: number) => void;
    clearCompareArray: () => void;
}

const CompareContext = createContext<CompareContextType | undefined>(undefined);

interface CompareProviderProps {
    children: ReactNode;
}

export const CompareProvider: React.FC<CompareProviderProps> = ({children}) => {
    const [compareArray, setCompareArray] = useState<number[]>(() => {
        const storedData = localStorage.getItem("compareArray");
        return storedData ? JSON.parse(storedData) : [];
    });
    const toggleCompareArray = (id: number) => {
        setCompareArray((prevArray) => {
            let updatedArray;
            if (prevArray.includes(id)) {
                updatedArray = prevArray.filter((item) => item !== id);
            }
            else {
                if (prevArray.length >= 3) {
                    updatedArray = [...prevArray.slice(1), id];
                }
                else {
                    updatedArray = [...prevArray, id];
                }
            }
            return updatedArray;
        });
    };
    const clearCompareArray = () => {
        setCompareArray([]);
    };
    useEffect(() => {
        localStorage.setItem("compareArray", JSON.stringify(compareArray));
    }, [compareArray]);
    return (
        <CompareContext.Provider
            value={{
                compareArray,
                toggleCompareArray,
                clearCompareArray,
            }}
        >
            {children}
        </CompareContext.Provider>
    );
};
export const useCompare = (): CompareContextType => {
    const context = useContext(CompareContext);
    if (!context) {
        throw new Error("useCompare must be used within a CompareProvider");
    }
    return context;
};
